import React from 'react';

import Fechamento from '../Fechamento';

const FechamentoConferencia: React.FC = () => {
  return <Fechamento tipo="fechamentoconferencia" />;
};

export default FechamentoConferencia;
